export const environment = {
  production: true,
  unit_test: false,
  target_build: 'production',
  compile_date: 'v1783556030979',
};
